const configData = {};

export class Config {
    constructor({ promConfig, tempDeps }) {
        configData.appState = {
            // static data
            CURRENT_DOMAIN: promConfig.currentDomain, // without protocol
            DEFAULT_ORIGIN: promConfig.defaultOrigin, // my. domain with protocol
            PORTAL_DOMAIN: promConfig.portalHomePage, // with protocol
            PERSONAL_DATA_PROCESSING_URL: promConfig.personalDataProcessDoc,
            KOMORA_URL: promConfig.komoraUrl,

            // cs config boolean
            BESIDA_IS_MOBILE: promConfig.besidaIsMobile,
            IS_SUDO_MODE: promConfig.userIsSudoMode,
            IS_RU_PROM: promConfig.isRuprom,
            IS_BEL_PROM: promConfig.isBelprom,
            IS_KZ_PROM: promConfig.isKzprom,
            IS_DEBUG: promConfig.isDebug,

            // page depends data
            USER_ID: promConfig.userId,
            DEFAULT_CURRENCY_TEXT: promConfig.defaultCurrencyText,
            IS_PREMIUM_SERVICE_FREE: promConfig.isPremiumServiceFree,

            // feature flags
            NEW_RUSSIAN_POLICY_LAW: promConfig.vasNewRussianPolicyLaw,
            CONTENT_POWER_ENABLED: promConfig.contentPowerEnabled,
            CORE_BESIDA_IMAGE_UPLOAD: promConfig.coreBesidaImageUpload,
            CORE_BANNED_SKK_NOTIFICATION: promConfig.coreBannedSKKNotification,

            getSocketConnectionObj: promConfig.getSocketConnectionObj,
            addStateCallback: promConfig.addStateCallback,

            faviconStaticUrls: {
                standard: promConfig.standardFaviconUrl,
                newMsg: promConfig.newMsgFaviconUrl
            }
        };

        configData.deps = {
            // analitics and prosale
            // improve it`s critical, to have this deps in @evo npm package
            FormTracker: tempDeps.FormTracker,
            tracking: tempDeps.tracking,
        };
    }

    static get data() {
        return configData;
    }
}